import React, {useMemo} from "react"

import PropTypes from "prop-types"

import {useCurrentWidth} from "../../hooks/useIsResponsive"
import sizes from "../../styles/_default.sizes.module.scss"
import {getBannerSrc} from "../../utils/bannerUtil"

import "./index.scss"

const StaticBanner = ({
    alt,
    images,
    desktopHeight = "200px",
    mobileHeight = "125px",
    borderStyle = "none",
    ...props
}) => {
    const width = useCurrentWidth()

    const imgSrc = useMemo(() => getBannerSrc(width, images), [images, width])

    const bannerStyle = useMemo(
        () => ({
            height: width > parseInt(sizes.mobileWidth) ? desktopHeight : mobileHeight,
            border: borderStyle,
        }),
        [borderStyle, desktopHeight, mobileHeight, width],
    )

    return (
        <div className="static-banner" {...props}>
            <img alt={alt} src={imgSrc} style={bannerStyle} />
        </div>
    )
}

StaticBanner.propTypes = {
    alt: PropTypes.string.isRequired,
    borderStyle: PropTypes.string,
    desktopHeight: PropTypes.string,
    images: PropTypes.shape({
        from1280To1500: PropTypes.string,
        from1024To1280: PropTypes.string,
        from768To1024: PropTypes.string,
        from480To768: PropTypes.string,
        from320To480: PropTypes.string,
    }).isRequired,
    mobileHeight: PropTypes.string,
}

export default StaticBanner
